import React, { useState } from "react";
import { Family } from "../../pageInside/Rolle";
import Modal from 'react-bootstrap/Modal';
import { elakayAutoText } from "../../pageInside/dataElakay";



const D = {
  blue: "#3b82f6", blueLt: "#dbeafe",
  green: "#10b981", greenLt: "#f0fdf4",
  red: "#ef4444", redLt: "#fff5f5",
  txt1: "#0f172a", txt2: "#475569", txt3: "#94a3b8",
  border: "#e2e8f0", bg: "#f8fafc",
  font: "'Inter','Segoe UI',system-ui,sans-serif",
  radius: 8,
};

var fileAdding = { title: '', error: '' };

const emailDataHtml = (jsonInput, htmlTemplate) => {
  const checkIfFunction = (f) => typeof f === 'object' ? true : false;

  const replaceObj = (array, obj, key, arrayRepl) => {
    let linkData;
    let data;
    for (let i = 0; i < array?.length; i++) {
      linkData = "${" + key + "." + array[i] + "}";
      data = obj[key][array[i]];
      arrayRepl.push([linkData, data]);
    }
  };

  const secondaireData = (prObj, seObj, key, arrayRepl) => {
    let newArray;
    let linkData;
    let data;
    if (checkIfFunction(seObj)) {
      newArray = Object.keys(seObj ? seObj : {});
      replaceObj(newArray, prObj, key, arrayRepl);
    } else {
      linkData = "${" + key + "}";
      data = prObj[key];
      arrayRepl.push([linkData, data]);
    }
  };

  const htmlReplaceData = (obj) => {
    let arrayRepl = [];
    let primaireData = Object.keys(obj ? obj : {});
    primaireData.forEach((da => secondaireData(obj, obj[da], da, arrayRepl)));
    return arrayRepl;
  };

  const handleRunCode = () => {
    try {
      const data = JSON.parse(jsonInput);
      let dynamicHtml = htmlTemplate;
      let arrayReplace = htmlReplaceData(data);
      for (let i = 0; i < arrayReplace?.length; i++) {
        let name = arrayReplace[i][1];
        let linkName = arrayReplace[i][0];
        dynamicHtml = dynamicHtml.replace(linkName, name);
      }
      return dynamicHtml;
    } catch (error) {
      console.error('Invalid JSON:', error);
    }
  };

  return handleRunCode();
};

const isObjectValid = (obj) => {
  if (obj === null || obj === undefined) return false;
  if (typeof obj === 'object' && !Array.isArray(obj)) {
    for (const key in obj) {
      if (!isObjectValid(obj[key])) return false;
    }
    return true;
  }
  if (Array.isArray(obj)) return obj.every(item => isObjectValid(item));
  return obj !== null && obj !== '' && obj !== undefined;
};

const FormPageDataMail = (props) => {
  const {
    laguangeElakay, infoSource, editAddByJson = false,
    getDataEmail, editAdd, setEditAdd,
    nameObj, paragra, setParagra, ObjetPage,
    edit_add, token, Alllanguage, AlllanguageSelect,
    languageUsertra, languageTradictor,
    updateLanguageElakay0, deleteLanguageElakay0,
    updateLanguageFileUp, buttonAddLanguage
  } = props;

  const [getNewDataEmail, setNewDataEmail] = useState({});
  const [checkdeletePara, setCheckDeletePara] = useState(false);
  const [error, setError] = useState('');
  const [deletePara, setDeletePara] = useState(false);
  const [showEmailPage, setShowEmailPage] = useState(false);
  const [htmlTemplate, setHtmlTemplate] = useState('<!-- enter your HTML Et CSS template here...-->');
  const [priObj, setPriObj] = useState({});
  const [objet, setObejet] = useState({});

  const inputOK = (a, b, c) => {
    if (c == undefined) return { v: b, s: 'neutral' };
    else if (c == {}) return { v: "", s: 'invalid' };
    else if (checkUndefName(c, a)) return { v: c[a], s: 'valid' };
    else return { v: "", s: 'invalid' };
  };

  const buttonAdd = () => {
    let data = objet;
    updateLanguageElakay0(languageTradictor._id, token,
      { [nameObj]: { _id: getNewDataEmail._id, data } }, Family()
    ).then(data => {
      if (data.error) { setError(data.error); }
      else {
        setNewDataEmail({}); setObejet({}); setPriObj({});
        AlllanguageSelect(); languageUsertra();
      }
    });
  };

  const buttonDelPara = () => {
    deleteLanguageElakay0(languageTradictor._id, getNewDataEmail._id, nameObj, token).then(data => {
      if (data.error) { setError(data.error); }
      else {
        setNewDataEmail({}); setObejet({}); setPriObj({});
        setCheckDeletePara(false); setDeletePara(false); setEditAdd(true);
        AlllanguageSelect(); languageUsertra();
      }
    });
  };

  const allSetData = (obj) => {
    setNewDataEmail(obj);
    setObejet(obj?.data || {});
  };

  const selTraDataMail = (title) => {
    languageTradictor[nameObj].filter(obj => obj.data.title == title && allSetData(obj));
    getDataEmail.filter(obj => obj.data.title == title && setHtmlTemplate(obj?.htmlTemplate || ''));
  };

  const TraDataMailBool = (array = [], title) =>
    array.filter(obj => obj.data.title == title)[0] ? true : false;

  const getIndexByTitle = (array, title) =>
    array && array.findIndex(item => item.data.title != 'about us' && item?.data?.title === title);

  const handleTilteData = () => event => {
    setNewDataEmail({}); setObejet({}); setPriObj({});
    const title = event.target.value;
    const index = title ? getIndexByTitle(getDataEmail, title) : -1;
    if (index === -1) { allSetData({}); return; }
    setPriObj(getDataEmail[index]?.data || {});
    TraDataMailBool(languageTradictor[nameObj], getDataEmail[index].data.title)
      ? selTraDataMail(getDataEmail[index].data.title)
      : setObejet(getDataEmail[index].data);
  };

  const handleChange = name => event => {
    const value = event.target.value;
    let pname = name[0];
    let sname = name[1];
    if (name?.length == 2) {
      setObejet({ ...priObj, [pname]: { ...priObj[pname], [sname]: value } });
    } else {
      setObejet({ ...priObj, [pname]: value });
    }
  };

  const checkIfFunction = (f) => typeof f === 'object' ? true : false;

  const checkUndefName = (a, b) => {
    let aa = a && Object.keys(a);
    return a && aa.includes(b);
  };

  const selNewName = (a, b) => a ? a : b;

  const deepGet = (obj, path) =>
    path.split('.').reduce((acc, part) => acc && acc[part], obj);

  // ── shared style helpers ──────────────────────────────────────────────────
  const inpSt = (s) => ({
    width: "100%", padding: "7px 10px", boxSizing: "border-box",
    border: `1px solid ${s === 'invalid' ? D.red : D.border}`,
    borderRadius: D.radius, fontSize: 13, color: D.txt1, fontFamily: D.font,
    background: s === 'invalid' ? D.redLt : "#fff", outline: "none",
  });

  const lblSt = {
    display: "block", fontSize: 11, fontWeight: 700, color: D.txt3,
    textTransform: "uppercase", letterSpacing: 0.6, marginBottom: 4,
  };

  const txt = (key) => {
    const val = infoSource.laguangeElakay?.("frontElakayHardcodedText", infoSource.languageAPI)?.languageFormPageDataMail?.[key];
    return typeof val === 'string' ? val : '';
  };

  const __elakayText = (key, fallback = '') => {
    const val = infoSource?.laguangeElakay?.("frontElakayHardcodedText", infoSource.languageAPI)?.formPageDataMail?.[key];
    return typeof val === 'string' ? val : fallback;
  };

  // ── sub-renders ───────────────────────────────────────────────────────────
  const selectObArData = () => (
    <div style={{ marginBottom: 16 }}>
      <div style={{ marginBottom: 8 }}>
        {(getNewDataEmail && getNewDataEmail._id == undefined)
          ? <span style={{ fontSize: 13, fontWeight: 700, color: D.blue }}>{elakayAutoText("h_109b936ad40f2c", "+ Add")}{priObj.title}</span>
          : <span style={{ fontSize: 13, fontWeight: 700, color: D.green }}>{elakayAutoText("h_7fcc836ad1168a", "✏ Edit")}{priObj.title}</span>
        }
      </div>
      <label style={lblSt}>{__elakayText("t001", "data title for edit")}</label>
      <select onChange={handleTilteData()}
        value={priObj && priObj.title != undefined ? priObj.title : ''}
        style={{ width: "100%", padding: "7px 10px", boxSizing: "border-box", border: `1px solid ${D.border}`, borderRadius: D.radius, fontSize: 13, color: D.txt1, fontFamily: D.font, background: "#fff", outline: "none", cursor: "pointer" }}>
        <option value={''}>{txt("t003")}</option>
        {getDataEmail && getDataEmail?.map((ob, j) =>
          ob.data.title != 'about us' && <option key={j} value={ob.data.title}>{ob.data.title}</option>
        )}
      </select>
    </div>
  );

  const formInput1 = (a, b, i, akey, c) => {
    let inpClass = c == undefined ? "neutral" : checkUndefName(c, a) ? "valid" : 'invalid';
    return (
      <div key={i} style={{ marginBottom: 10 }}>
        <label style={lblSt}>{a}</label>
        {b?.length > 90
          ? <textarea onChange={handleChange([akey, a])} rows={4}
              placeholder={selNewName(objet[a], b)}
              value={selNewName(deepGet(objet, `${akey}.${a}`), '')}
              style={{ ...inpSt(inpClass), resize: "vertical", fontFamily: "monospace" }} />
          : <input onChange={handleChange([akey, a])} type="text"
              placeholder={selNewName(objet[a], b)}
              value={selNewName(deepGet(objet, `${akey}.${a}`), '')}
              style={inpSt(inpClass)} />
        }
      </div>
    );
  };

  const formInput0 = (a, b, i, c) => {
    let oe1 = Object.entries(b);
    let inpClass = c == undefined ? "neutral" : checkUndefName(c, a) ? "valid" : 'invalid';
    return a != "title" && (
      <div key={i} style={{ marginBottom: 14 }}>
        <label style={checkIfFunction(b)
          ? { fontSize: 12, fontWeight: 700, color: D.txt2 }
          : lblSt}>
          {checkIfFunction(b) ? a.toUpperCase() : a}
        </label>
        {checkIfFunction(b)
          ? (
            <div style={{ background: D.bg, borderRadius: D.radius, border: `1px solid ${D.border}`, padding: "12px 14px", marginTop: 4 }}>
              {oe1?.map(([key, val], i) => formInput1(key, val, i, a))}
            </div>
          )
          : (
            <div style={{ marginTop: 4 }}>
              {b?.length > 90
                ? <textarea onChange={handleChange([a])} rows={4}
                    placeholder={selNewName(objet[a], b)}
                    value={selNewName(objet[a], '')}
                    style={{ ...inpSt(inpClass), resize: "vertical", fontFamily: "monospace" }} />
                : <input onChange={handleChange([a])} type="text"
                    placeholder={selNewName(objet[a], b)}
                    value={selNewName(objet[a], '')}
                    style={inpSt(inpClass)} />
              }
            </div>
          )
        }
      </div>
    );
  };

  const ArrayFormInput = () => {
    let oe = priObj && Object.entries(priObj);
    return (
      <div>
        {priObj && oe?.map(([key, val], i) => formInput0(key, val, i))}
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 12 }}>
          {(isObjectValid(objet) && Object.keys(objet)?.length !== 0)
            ? <button type="button" onClick={() => buttonAdd()}
                style={{ padding: "8px 20px", borderRadius: D.radius, border: "none", background: D.green, color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: D.font }}>
                {txt("t004")}
              </button>
            : <button disabled
                style={{ padding: "8px 20px", borderRadius: D.radius, border: "none", background: "#f1f5f9", color: D.txt3, fontSize: 13, fontWeight: 600, cursor: "not-allowed", fontFamily: D.font }}>
                {txt("t005")}
              </button>
          }
        </div>
      </div>
    );
  };

  const deleteAgree = () => (
    <Modal show={deletePara} onHide={() => setDeletePara(false)}
      size="lg" dialogClassName="modal-90w" aria-labelledby="del-modal-datamail" centered>
      <Modal.Header closeButton>
        <Modal.Title id="del-modal-datamail">
          <span style={{ fontSize: 16, fontWeight: 700, fontFamily: D.font }}>
            {infoSource.language(infoSource, "title", "delThtems")}
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ padding: "8px 4px" }}>
          <div style={{
            display: "flex", alignItems: "flex-start", gap: 10, marginTop: 8,
            padding: "12px 14px", background: D.redLt, borderRadius: 8,
            border: `1px solid #fca5a5`,
          }}>
            <input
              onChange={() => setCheckDeletePara(!checkdeletePara)}
              type="checkbox" checked={checkdeletePara ? true : false}
              id="chButAgreeDataMail"
              style={{ width: 16, height: 16, marginTop: 2, cursor: "pointer", accentColor: D.red }} />
            <label htmlFor="chButAgreeDataMail"
              style={{ fontSize: 13, color: "#991b1b", cursor: "pointer", fontFamily: D.font }}>
              {infoSource.language(infoSource, "title", "chButAgree")}
            </label>
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 14 }}>
            {getNewDataEmail && getNewDataEmail._id != undefined && checkdeletePara
              ? <button onClick={() => buttonDelPara()}
                  style={{ padding: "8px 20px", borderRadius: D.radius, border: "none", background: D.red, color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: D.font }}>
                  {txt("t001")}
                </button>
              : <button disabled
                  style={{ padding: "8px 20px", borderRadius: D.radius, border: "none", background: "#f1f5f9", color: D.txt3, fontSize: 13, fontWeight: 600, cursor: "not-allowed", fontFamily: D.font }}>
                  {txt("t002")}
                </button>
            }
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );

  let email_Actiivation = emailDataHtml(
    JSON.stringify(getNewDataEmail.data, null, 2),
    htmlTemplate
  );

  const printListeShop = () => (
    <Modal size="xl" show={showEmailPage} onHide={() => setShowEmailPage(false)}
      dialogClassName="modal-90w" aria-labelledby="email-preview-modal" centered>
      <Modal.Header closeButton>
        <Modal.Title id="email-preview-modal">
          <span style={{ fontSize: 14, fontWeight: 700, fontFamily: D.font }}>
            {txt("t006")}
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: 0 }}>
        <iframe
          srcDoc={email_Actiivation}
          title={txt("t006")}
          sandbox="allow-scripts"
          style={{ backgroundColor: '#FFFFFF', width: '100%', minHeight: '800px', border: 'none', display: 'block' }}
        />
      </Modal.Body>
    </Modal>
  );

  return (
    <>
      {selectObArData()}

      {error && (
        <div style={{ display: "flex", alignItems: "flex-start", gap: 8, padding: "10px 14px", background: D.redLt, borderRadius: 8, border: `1px solid #fca5a5`, marginBottom: 10 }}>
          <span style={{ fontSize: 16, flexShrink: 0 }}>⚠</span>
          <span style={{ fontSize: 12, color: "#991b1b" }}>{error}</span>
        </div>
      )}

      {/* Action bar */}
      {getNewDataEmail && getNewDataEmail._id != undefined && (
        <div style={{ display: "flex", gap: 10, marginBottom: 16 }}>
          <button type="button" onClick={() => setShowEmailPage(true)}
            style={{ padding: "7px 16px", borderRadius: D.radius, border: `1px solid ${D.border}`, background: "#fff", color: D.txt2, fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: D.font }}>
            {txt("t007")}
          </button>
          <button type="button" onClick={() => setDeletePara(true)}
            style={{ padding: "7px 16px", borderRadius: D.radius, border: `1px solid #fca5a5`, background: D.redLt, color: D.red, fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: D.font, marginLeft: "auto" }}>
            {txt("t008")}
          </button>
        </div>
      )}

      {ArrayFormInput()}
      {deleteAgree()}
      {printListeShop()}
    </>
  );
};

export default FormPageDataMail;
